import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { toast } from "sonner";
import { Loader2, ScrollText, Search } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setLogs(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))).finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter((l) =>
    (l.action || "").includes(q.toLowerCase()) || (l.user_email || "").includes(q.toLowerCase())
  );

  const resultColor = (r) => r === "failed" ? "text-rose-600" : r === "override" || (r || "").includes("warning") ? "text-amber-600" : "text-red-600";

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight flex items-center gap-2"><ScrollText className="w-7 h-7 text-red-600" /> Auditlog</h1>
        <p className="text-muted-foreground mt-1">Registratie van belangrijke acties (nieuwste eerst).</p>
      </div>
      <div className="relative max-w-sm">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Zoek op actie of gebruiker" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="audit-search" />
      </div>
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Tijd</TableHead><TableHead>Gebruiker</TableHead><TableHead>Actie</TableHead>
              <TableHead>Object</TableHead><TableHead>Resultaat</TableHead><TableHead className="hidden md:table-cell">IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filtered.map((l) => (
              <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                <TableCell className="text-xs whitespace-nowrap font-mono">{new Date(l.timestamp).toLocaleString("nl-NL")}</TableCell>
                <TableCell className="text-sm">{l.user_email || "—"}</TableCell>
                <TableCell className="text-sm font-medium">{l.action}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{l.object_type || "—"}</TableCell>
                <TableCell className={`text-xs font-semibold ${resultColor(l.result)}`}>{l.result}</TableCell>
                <TableCell className="hidden md:table-cell text-xs text-muted-foreground font-mono">{l.ip || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
